import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "../../utils/api";
import { useAuth } from "../../context/AuthContext";

const SubscriptionCallback = () => {
  const { refreshUser } = useAuth();
  const [params] = useSearchParams();
  const navigate = useNavigate();

useEffect(() => {
  const run = async () => {
    const reference = params.get("reference");

    if (!reference) {
      return navigate("/", { replace: true });
    }

    try {
      // 1. verify payment
      await api.get(`/subscription/verify?reference=${reference}`);

      // 2. refresh user — returns updated data AND writes to localStorage
      const updatedUser = await refreshUser();

      if (!updatedUser) {
        return navigate("/?payment=failure", { replace: true });
      }

      // 3. derive path from the RETURNED value, not context state
      const role = updatedUser?.role;
      const path =
        role === "student"
          ? "/student-home"
          : role === "tutor"
          ? "/tutor-home"
          : role === "institution"
          ? "/academy-home"
          : "/";

      // 4. Small flush to let React commit the state update before navigation
      await new Promise((res) => setTimeout(res, 0));

      navigate(`${path}?payment=success`, { replace: true });

    } catch (err) {
      console.log("callback error:", err);
      navigate("/?payment=failure", { replace: true });
    }
  };

  run();
}, []);

  return <div>Verifying payment...</div>;
};

export default SubscriptionCallback;